module.exports = __webpack_public_path__ + "static/arnold-logo-47b0fee8e027ac331b94c9bb4b177adf.png";